import React from "react";
import { Route, Switch } from "react-router-dom";

import asyncComponent from "./components/async.component";
import Compact from "./layouts/layout-compact/layout-compact.component";
import NoLayout from "./layouts/layout-none/layout-none.component";
import authHandler from "./utilities/AuthHandler";

// DASHBOARD ROUTE
const AsyncOrdersDashboard = asyncComponent(() => import("./containers/dashboards/orders/orders.component"));
const AsyncProductsDashboard = asyncComponent(() => import("./containers/dashboards/products/products.component"));

// SETTINGS ROUTES
const AsyncSettings = asyncComponent(() => import("./containers/settings/settings.component"));

// AUTHENTICATION ROUTES
const AsyncLogin = asyncComponent(() => import("./containers/authentication/login/login.component"));
// const AsyncRegister = asyncComponent(() => import('./containers/authentication/register/register.component'));
// const AsyncProfile = asyncComponent(() => import('./containers/authentication/profile/profile.component'));
const AsyncForgot = asyncComponent(() => import("./containers/authentication/forgot-password/forgot-password.component"));

// ERROR ROUTES
const AsyncError404 = asyncComponent(() => import("./containers/errors/404.component"));
const AsyncError500 = asyncComponent(() => import("./containers/errors/500.component"));
const AsyncNotFound = asyncComponent(() => import("./containers/not-found/not-found.component"));

// PAGES ROUTES
const PubRoute = ({ component: Component, layout: Layout, ...rest }) => (
    <Route
        {...rest}
        render={(props) => (
            <Layout>
                <Component {...props} auth={authHandler} />
            </Layout>
        )}
    />
);

const PrvtRoute = ({ component: Component, layout: Layout, ...rest }) => (
    <Route
        {...rest}
        render={(props) => (
            <Layout>
                <Component {...props} auth={authHandler} />
            </Layout>
        )}
    />
);

const CompactLayout = (props) => <Compact>{props.children}</Compact>;

// TODO: Consider looping through an object containing all routes
export default ({ childProps, layout }) => {
    let activeLayout;
    switch (layout.currentLayout) {
        case "compact":
            activeLayout = CompactLayout;
            break;
        default:
            activeLayout = CompactLayout;
    }

    return (
        <Switch>
            <PrvtRoute path="/orders" exact component={AsyncOrdersDashboard} props={childProps} layout={activeLayout} />
            <PrvtRoute path="/orders/:storeId" exact component={AsyncOrdersDashboard} props={childProps} layout={activeLayout} />

            <PrvtRoute path="/products" exact component={AsyncProductsDashboard} props={childProps} layout={activeLayout} />

            <PrvtRoute path="/settings" exact component={AsyncSettings} props={childProps} layout={activeLayout} />
            <PubRoute path="/login" exact component={AsyncLogin} props={childProps} layout={NoLayout} />

            {/* <PubRoute path="/register" exact component={AsyncRegister} props={childProps} layout={NoLayout} /> */}
            <PubRoute path="/forgot-password" exact component={AsyncForgot} props={childProps} layout={NoLayout} />
            {/* <PrvtRoute path="/profile" exact component={AsyncProfile} props={childProps} layout={activeLayout} /> */}

            <PubRoute path="/errors/404" exact component={AsyncError404} props={childProps} layout={NoLayout} />
            <PubRoute path="/errors/500" exact component={AsyncError500} props={childProps} layout={NoLayout} />

            <PrvtRoute path="/" component={AsyncOrdersDashboard} props={childProps} layout={activeLayout} />
            <PubRoute component={AsyncNotFound} layout={NoLayout} />
        </Switch>
    );
};



// WEBPACK FOOTER //
// ./src/routes.js